import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { TipoPuntoVentaModel } from '../models/TipoPuntoVentaModel';
import {
  obtenerTiposPuntoVentaService,
  obtenerTipoPuntoVentaPorIdService,
} from '../../../../service/catalogos/TipoPuntoVenta';

export const useObtenerTiposPuntoVenta = (reload: number) => {
  const [data, setData] = useState<TipoPuntoVentaModel[]>([]);
  const [count, setCount] = useState(0);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      setLoadingRequest(true);
      const res = await obtenerTiposPuntoVentaService()
        .then()
        .catch(() => {
          setLoadingRequest(false);
          history.push('/error/500');
        });
      if (res) {
        setData(res.rows ?? res);
        setCount(res.count ?? (res.rows ?? res).length);
        setLoadingRequest(false);
      }
    };
    fetchData();
  }, [reload]);

  return { data, count, loadingRequest };
};

export const useObtenerTipoPorId = (id: number) => {
  const initModel: TipoPuntoVentaModel = { id: 0, nombre: '', codigo: '', activo: true };
  const [initValues, setInitValues] = useState<TipoPuntoVentaModel>(initModel);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const res = await obtenerTipoPuntoVentaPorIdService(id)
        .then()
        .catch(() => {
          history.push('/error/500');
        });
      if (res) {
        setInitValues(res);
      }
    };
    if (id) {
      fetchData();
    } else {
      setInitValues(initModel);
    }
  }, [id]);

  return { initValues };
};
